import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LabelValeur } from 'app/shared/models/LabelValeur/labelValeur';
import { TitleService } from 'app/shared/services/title/title.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-label-valeur',
  templateUrl: './label-valeur.component.html',
  styleUrls: ['./label-valeur.component.scss']
})
export class LabelValeurComponent implements OnInit {
  item: LabelValeur[];

  constructor(
    private titleService: TitleService,
    private userService: UserService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const title = this.route.snapshot.params.title;
    this.titleService.title.next(this.route.snapshot.params.name);
    this.getLabelValeur(title);
  }

  private getLabelValeur(title: string): void {
    this.userService.getLabelValeur(title).subscribe(res => {
      this.item = res;
    });
  }

}
